"use strict";

exports.__esModule = true;
exports.UpdateDashboardScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _DashboardDataProvider = require("../DashboardDataProvider");
var _Core = require("../../Core");
var _App = require("../../App");
var _DashboardEditor = require("../DashboardEditor");
var _DashboardCollection = require("../DashboardCollection");
var _API = require("../../API");
var _System = require("../../../System");
var _Notifications = require("../../Notifications");
var _DashboardTagContext = require("../DashboardTagContext");
var _Widgets = require("../../Widgets");
var _ConfigurableLayout = require("../../ConfigurableLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Screen which allows users to update existing dashboards.
 */
var UpdateDashboardScreen = exports.UpdateDashboardScreen = function UpdateDashboardScreen(props) {
  var widgets = _react["default"].useContext(_Widgets.WidgetsContext);
  var match = props.match,
    history = props.history;
  var id = match.params.id;
  var dashboardCollection = _react["default"].useContext(_DashboardCollection.DashboardCollectionContext);
  var _React$useContext = _react["default"].useContext(_Notifications.NotificationContext),
    showNotification = _React$useContext.showNotification;
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  var handleSubmit = function handleSubmit(dashboard) {
    var id = dashboard.id,
      name = dashboard.name,
      tags = dashboard.tags,
      element = dashboard.element;
    return dashboardCollection.update({
      id: id,
      name: name,
      tags: tags,
      element: element
    }).then(function (result) {
      history.push((0, _System.getScreenURL)("Dashboard", result, (0, _System.getLocationQuery)(history.location)));
      showNotification(_Notifications.NOTIFICATION_UPDATED_DASHBOARD);
    });
  };
  var handleDuplicate = function handleDuplicate(dashboard) {
    var name = dashboard.name,
      tags = dashboard.tags,
      element = dashboard.element;
    var escapedName = name.replace(/\s/gi, "-");
    escapedName = escapedName.replace(/[`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, "");
    var encodedName = encodeURIComponent(escapedName);
    var id = encodedName.toLowerCase().trim();
    return dashboardCollection.create({
      id: id,
      name: name,
      tags: tags,
      element: element
    }).then(function (result) {
      history.push((0, _System.getScreenURL)("Dashboard", result, (0, _System.getLocationQuery)(history.location)));
      showNotification(_Notifications.NOTIFICATION_DUPLICATED_DASHBOARD);
    });
  };
  var handleDelete = function handleDelete(dashboard) {
    return dashboardCollection["delete"](dashboard.id).then(function () {
      history.push((0, _System.getScreenURL)("DashboardList"));
      showNotification(_Notifications.NOTIFICATION_DELETED_DASHBOARD);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
    collection: dashboardCollection,
    id: id
  }, function (_ref) {
    var _data$element, _data$element2;
    var data = _ref.data,
      error = _ref.error;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("DashboardScreen.title.error", "Error Loading Dashboard")
      }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("DashboardScreen.navbar.error", "Error Loading Dashboard")
      }), /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      }));
    }
    if (!data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("DashboardScreen.loadingText", "Loading {id} ...", {
          id: id
        })
      }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("DashboardScreen.loadingText", "Loading {id} ...", {
          id: id
        })
      }), /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: data.name,
      "data-testid": "UpdateDashboardScreen"
    }, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutVisibility, {
      layoutRolesVisibilities: data == null || (_data$element = data.element) == null || (_data$element = _data$element.props) == null ? void 0 : _data$element.rolesVisibility,
      layoutUsersVisibilities: data == null || (_data$element2 = data.element) == null || (_data$element2 = _data$element2.props) == null ? void 0 : _data$element2.usersVisibility
    }, /*#__PURE__*/_react["default"].createElement(_DashboardDataProvider.DashboardDataProvider, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("UpdateDashboardScreen.navbar.title", "Edit Dashboard: {dashboardName}", {
        dashboardName: data.name
      }),
      dashboard: data
    }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_Core.DragDropContextProvider, null, /*#__PURE__*/_react["default"].createElement(_DashboardEditor.DashboardEditor, {
      widgets: widgets.dashboardWidgets,
      onSubmit: handleSubmit,
      onDuplicate: handleDuplicate,
      onDelete: handleDelete,
      value: data,
      dashboardCollection: dashboardCollection
    })))))));
  });
};